// src/bootstrap/http/auth.js

import axios from 'axios'
import Vue from 'vue'
import router from '@/router'

/**
 * Always read token dynamically.
 * This avoids stale-token bugs after login / refresh / logout.
 */
function getToken () {
  return localStorage.getItem('token')
}

/**
 * Centralized handler for auth failure.
 * Keeps behavior consistent across HTTP clients.
 */
function handleUnauthorized () {
  if (router.currentRoute.name !== 'Login') {
    router.push('/login')
  }
}

/* =========================
   AXIOS
   ========================= */

// Inject token on every request
axios.interceptors.request.use(config => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// React to backend auth rejection
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      handleUnauthorized()
    }
    return Promise.reject(error)
  }
)

/* =========================
   VUE-RESOURCE
   ========================= */

Vue.http.interceptors.push((request, next) => {
  const token = getToken()
  if (token) {
    request.headers.set('Authorization', `Bearer ${token}`)
  }

  next(response => {
    if (response.status === 401) {
      handleUnauthorized()
    }
    return response
  })
})
